import React from 'react';
import { ArrowDownRight } from 'lucide-react';
export function Hero() {
  return <section className="border-b-2 border-black" data-id="element-33">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-34">
        {/* Manifesto Side */}
        <div className="p-8 md:p-12 lg:p-20 border-b-2 lg:border-b-0 lg:border-r-2 border-black flex flex-col justify-between min-h-[60vh]" data-id="element-35">
          <div data-id="element-36">
            <h1 className="text-5xl md:text-7xl font-bold leading-tight tracking-tighter mb-8" data-id="element-37">
              WE DON'T DO
              <br data-id="element-38" />
              MARKETING
              <br data-id="element-39" />
              SPEAK.
            </h1>
            <p className="text-xl md:text-2xl font-medium max-w-md leading-relaxed" data-id="element-40">
              We do results. Raw numbers. <br data-id="element-41" />
              <span className="text-[#ff0000]" data-id="element-42">No fluff. No hidden fees.</span>
            </p>
          </div>

          <div className="mt-12" data-id="element-43">
            <ArrowDownRight className="w-12 h-12 text-[#ff0000]" data-id="element-44" />
          </div>
        </div>

        {/* Terminal/Data Side */}
        <div className="bg-black text-white p-8 md:p-12 font-mono text-sm md:text-base overflow-hidden relative" data-id="element-45">
          <div className="absolute top-4 right-4 text-[#ff0000] animate-pulse" data-id="element-46">
            ● LIVE_DATA_FEED
          </div>

          <div className="space-y-6 mt-8" data-id="element-47">
            <div className="border border-white/20 p-4" data-id="element-48">
              <div className="text-gray-400 mb-1" data-id="element-49"> // TOTAL_SPEND_PLN</div>
              // TOTAL_SPEND_PLN
            </div>
            <div className="text-3xl md:text-4xl text-white" data-id="element-50">
              1,240,500.00 PLN
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-51">
            <div className="border border-white/20 p-4" data-id="element-52">
              <div className="text-gray-400 mb-1" data-id="element-53"> // AVG_ROAS</div>
              // AVG_ROAS
            </div>
            <div className="text-2xl text-[#ff0000]" data-id="element-54">4.82x</div>
          </div>
          <div className="border border-white/20 p-4" data-id="element-55">
            <div className="text-gray-400 mb-1" data-id="element-56"> // CONVERSIONS</div>
            // CONVERSIONS
          </div>
          <div className="text-2xl" data-id="element-57">14,203</div>
        </div>
      </div>

      <div className="border border-white/20 p-4" data-id="element-58">
        <div className="text-gray-400 mb-2" data-id="element-59"> // RECENT_LOGS</div>
        // RECENT_LOGS
      </div>
      <div className="space-y-2 font-mono text-xs md:text-sm opacity-80" data-id="element-60">
        <p className="flex justify-between" data-id="element-61">
          <span data-id="element-62">[10:42:15] CAMPAIGN_ID_882</span>
          <span data-id="element-63">ROAS: 5.2x</span>
        </p>
        <p className="flex justify-between" data-id="element-64">
          <span data-id="element-65">[10:41:03] BID_ADJUSTMENT</span>
          <span data-id="element-66">+12%</span>
        </p>
        <p className="flex justify-between" data-id="element-67">
          <span data-id="element-68">[10:38:55] NEW_CREATIVE_TEST</span>
          <span data-id="element-69">ACTIVE</span>
        </p>
        <p className="flex justify-between text-[#ff0000]" data-id="element-70">
          <span data-id="element-71">[10:35:22] CONVERSION_EVENT</span>
          <span data-id="element-72">+450 PLN</span>
        </p>
      </div>
    </section>;
}